module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Hat-f741fe3be11b9ce62eecc5b8dfc6059b.svg";